import { render, staticRenderFns } from "./coursegerdetails.vue?vue&type=template&id=4e528f6a"
import script from "./coursegerdetails.vue?vue&type=script&lang=js"
export * from "./coursegerdetails.vue?vue&type=script&lang=js"
import style0 from "./coursegerdetails.vue?vue&type=style&index=0&id=4e528f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports